export default __webpack_public_path__ + "static/media/precincts2019.1150de99.txt";